import React, { useState } from 'react';
import {
  Grid, Typography, IconButton, Accordion, AccordionSummary,
  AccordionDetails, Divider, Card, CardContent, CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronRight, ExpandMore, Clear } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  cardStyle: {
    cursor: 'pointer',
    backgroundColor: '#FFF8F8',
    border: '1px solid black',
    borderRadius: '4px',
    width: '100%',
    height: '100%',
    '&:hover': {
      backgroundColor: '#FFD7D7',
    },
  },
  cardSelected: {
    cursor: 'pointer',
    backgroundColor: '#FFD7D7',
    border: '1px solid black',
    borderRadius: '4px',
    width: '100%',
    height: '100%',
  },
  cardContent: {
    height: 'inherit',
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  accordionSummary: {
    paddingLeft: 0,
    minHeight: '40px',
    '&.Mui-expanded': {
      minHeight: '40px',
    },
    '& .MuiAccordionSummary-content': {
      paddingLeft: 0,
      margin: '8px 0 0 0',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: '8px 0 0 0',
    },
  },
  clearLink: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const CARDS = [
  { key: 'plannedBatches',                   label: 'Planned Batches',                    viewOption: 'plannedBatches' },
  { key: 'batchesUnderManufacturing',        label: 'Batches Under Manufacturing',        viewOption: 'underManufacturing' },
  { key: 'batchesUnderTesting',              label: 'Batches Under Testing',              viewOption: 'underTesting' },
  { key: 'batchesPendingCMORelease',         label: 'Batches Pending CMO Release',        viewOption: 'pendingCMORelease' },
  { key: 'batchesPendingAmgenRelease',       label: 'Batches Pending Sponsor Release',    viewOption: 'pendingAmgenRelease' },
  { key: 'batchesReadyForShipment',          label: 'Batches Ready for Shipment',         viewOption: 'readyForShipment' },
  { key: 'batchesShipped',                   label: 'Batches Shipped',                    viewOption: 'shipped' },
  { key: 'batchesDelayedOnHoldOrCancelled',  label: 'Batches Delayed, Hold or Cancelled', viewOption: 'delayedHoldCancelled' },
];

const QuickSummaryCards = ({ quickSummary, activeCard, onCardClick }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const getCount = (card) => {
    // if (card.key === 'plannedBatches') return 0;
    // if (card.key === 'batchesShipped') return 5;
    return quickSummary[card.key] || 0;
  };

  const handleClearQuickSummary = (e) => {
    e.stopPropagation();
    onCardClick('all');
  };

  return (
    <>
      <Divider style={{ marginTop: '1rem' }} />
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        style={{ boxShadow: 'none', margin: 0 }}
      >
        <AccordionSummary className={classes.accordionSummary}>
          <Grid container style={{ justifyContent: 'space-between' }}>
            <Grid item>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  style={{ marginRight: '8px', padding: '4px' }}
                  onClick={() => setExpanded(!expanded)}
                  size="small"
                >
                  {expanded ? <ExpandMore /> : <ChevronRight />}
                </IconButton>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 600, fontSize: '1rem' }}
                >
                  Quick Summary:
                </Typography>
              </div>
            </Grid>
            {activeCard && activeCard !== 'all' && (
              <Grid item>
                <Typography
                  variant="caption"
                  color="primary"
                  onClick={handleClearQuickSummary}
                  className={classes.clearLink}
                >
                  Clear Quick Summary
                  <Clear color="primary" style={{ fontSize: 15 }} />
                </Typography>
              </Grid>
            )}
          </Grid>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '0 0.5rem 0.25rem 0.5rem' }}>
          <Grid
            container
            spacing={1}
            wrap="nowrap"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              minHeight: '110px',
              overflow: 'hidden',
            }}
          >
            {CARDS.map((card) => (
              <Grid key={card.key} item style={{ flex: '1 1 0', minWidth: 0, height: '110px' }}>
                <Card
                  className={activeCard === card.viewOption ? classes.cardSelected : classes.cardStyle}
                  onClick={() => onCardClick(card.viewOption)}
                >
                  <CardContent className={classes.cardContent}>
                    {quickSummary.loading ? (
                      <Grid container style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress color="primary" thickness={7} />
                      </Grid>
                    ) : (
                      <Grid container style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '2px' }}>
                          <Typography
                            style={{
                              textAlign: 'center',
                              fontWeight: 700,
                              fontSize: '2.75rem',
                              lineHeight: 1.1,
                            }}
                          >
                            {String(getCount(card)).padStart(2, '0')}
                          </Typography>
                        </Grid>
                        <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Typography
                            style={{
                              textAlign: 'center',
                              fontSize: '0.8rem',
                              fontWeight: 700,
                              lineHeight: 1.25,
                              wordWrap: 'break-word',
                              overflowWrap: 'break-word',
                              padding: '0 4px',
                            }}
                          >
                            {card.label}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Divider style={{ marginTop: '0.75rem' }} />
    </>
  );
};

export default QuickSummaryCards;
